import { useState } from 'react';
// import axios from 'axios';

export default function useToken() {
  /*const verify = async(token) => {
    let valid = await axios.post('/api/user/authenticate', {token}).then(resp=>resp.data);
    return valid;
  }*/

  const getToken = () => {
    const tokenString = sessionStorage.getItem('token');
    try {
      const userToken = tokenString && tokenString.length > 0 ? JSON.parse(tokenString) : '';
      let token = userToken && userToken.token ? userToken.token : '';
      // Doesn't meet reqs, Remove the 'token' item from sessionStorage
      if(!token) { 
        sessionStorage.removeItem('token');
        return false;
      } else {
        return token;
      }
    } catch(e) {
      // Doesn't meet reqs, Remove the 'token' item from sessionStorage
      sessionStorage.removeItem('token');
    }

    return false;
  }

  const saveToken = (userToken) => {
    sessionStorage.setItem('token', JSON.stringify(userToken));
    setToken(userToken.token);
  }

  const [token, setToken] = useState(getToken());

  return {
    setToken: saveToken,
    token
  }
}
